import "./LoginStyles.scss";
import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { FormFieldComponent, LoadingComponent, CheckBoxComponent } from "jsl-ui";
import { RegisterCompleteComponent } from "../RegisterCompleteComponent";
import Axios from "axios";
import { PublicController } from "../../../ajax/PublicController";

export class LoginComponent implements IJSLComponent {

    private tbUser = new FormFieldComponent({ id: "tbUser", label: "Login Name" });
    private tbName = new FormFieldComponent({ id: "tbName", label: "Echter Name *" });
    private tbPassword = new FormFieldComponent({ id: "tbPassword", label: "Passwort", type: "password" });
    private tbPassword2 = new FormFieldComponent({ id: "tbPassword2", label: "Passwort wiederholen", type: "password" });
    private tbEmail = new FormFieldComponent({ id: "tbEmail", label: "Email Adresse" });
    private validationInfo: IJSLVNode;
    private isLoading: boolean;
    private isRegister: boolean;
    private isRegisterComplete: boolean;
    private cb1 = new CheckBoxComponent({ label: "* ich stimme zu dass dieser Name bei hochgeladenen Funden öffentlich sichtbar anzeigt wird" });
    private cbValidation = false;

    public constructor(private redirect?: string) {
    }

    public render(): IJSLVNode {
        if (this.isRegisterComplete) {
            return new RegisterCompleteComponent().render();
        }
        return <div class="login-comp">
            <form>
                {this.tbUser}
                {this.tbPassword}
                {this.isRegister ?
                    <div>
                        {this.tbPassword2}
                        {this.tbName}
                        <div style={this.cbValidation ? "background:red" : ""}>
                            {this.cb1}
                        </div>
                        {this.tbEmail}
                        <div><i>Ich bestägige mit dieser Registrierung dass ich mindestens 18 Jahre alt bin</i></div>
                    </div> : null}
                {this.validationInfo}
                <div style="text-align:center">
                    {this.isLoading ? new LoadingComponent() :
                        (this.isRegister ?
                            <input class="genric-btn primary" click={this.register} value="Konto erstellen" /> :
                            <input class="genric-btn primary" type="submit" click={this.authenticate} value="Anmelden" />
                        )
                    }
                </div>
                {!this.isRegister ?
                    <div>
                        Noch kein Konto? <button class="genric-btn" click={this.showRegisterDlg}>Registrieren</button>
                    </div> : null}
            </form>
        </div>;
    }

    private authenticate(args: any) {
        args.preventDefault();
        this.isLoading = true;
        this.validationInfo = null;
        const bodyFormData = new FormData();
        bodyFormData.append("loginname", this.tbUser.getValue());
        bodyFormData.append("password", this.tbPassword.getValue());
        Axios.post("/user/authenticate", bodyFormData, {}).then(() => {
            if (this.redirect) {
                document.body.innerHTML = "";
                location.hash = "#" + this.redirect;
                location.reload();
            } else {
                location.href = "";
            }
        }).catch((e) => {
            this.validationInfo = <div class="error-msg">{e.response.data.title}</div>;
            this.isLoading = undefined;
            refresh();
        });
    }

    private showRegisterDlg(args) {
        args.preventDefault();
        this.isRegister = true;
    }

    private register(args) {
        if (!this.cb1.getValue()) {
            this.validationInfo = <div class="error-msg">Sie müssen zustimmen dass Ihr Name bei Funden angezeigt wird wenn Sie sich registieren möchten</div>;
            this.cbValidation = true;
            return;
        }
        args.preventDefault();
        this.isLoading = true;
        this.validationInfo = null;

        PublicController.Register({
            email: this.tbEmail.getValue(),
            password: this.tbPassword.getValue(),
            password2: this.tbPassword2.getValue(),
            login: this.tbUser.getValue(),
            name: this.tbName.getValue()
        }).then(() => {
            this.isRegisterComplete = true;
            refresh();
        }).catch((e) => {
            this.validationInfo = <div class="error-msg">{e.response.data.title}</div>;
            this.isLoading = undefined;
            refresh();
        });
    }

}

